<template>
    <div class="horse-edit-documents-generate">
        <div class="flex justify-content-between align-items-center">
            <div class="header">{{ $t('message.horseEdit.documents.generate.header') }}</div>
            <CustomSelectOneDocumentType name="type" :label="$t('message.horseEdit.documents.generate.documentType')"
                                         v-model="documentType" noPlaceholder class="w-4" />
        </div>
        <div class="flex align-items-center justify-content-center mt-5">
            <CustomButton :label="$t('message.horseEdit.documents.generate.action')" class="align-self-center"
                          @click="generateDocument"
                          :disabled="!canGenerateDocument" />
        </div>
    </div>
</template>

<script>
    import CustomSelectOne from "@/components/form/inner/CustomSelectOne.vue";
    import CustomButton from "@/components/form/CustomButton.vue";
    import CustomSelectOneDocumentType from "@/components/form/CustomSelectOneDocumentType.vue";
    import {generateDocument} from "@/swagger/vue-api-client";
    import {SystemRole} from "@/utils/SystemRole";

    export default {
        name: "HorseEditDocumentsGenerate",
        components: {
            CustomSelectOneDocumentType,
            CustomButton,
            CustomSelectOne,
        },

        props: {
            horse: null,
        },

        data() {
            return {
                documentType: null,
            };
        },

        computed: {
            canGenerateDocument() {
                const userRole = SystemRole.getUserRole();
                const allowedRoles = [SystemRole.ADMIN, SystemRole.THIRD_LEVEL_EDITOR, SystemRole.FOURTH_LEVEL_EDITOR];
                const hasAllowedRole = allowedRoles.includes(userRole);

                return hasAllowedRole
                       && this.horse.horseStatus === "REGISTER_IN_STUDBOOK"
                       && this.documentType != null
                       && !(this.documentType === "PASSPORT" && this.horse.countryOfImportId !== null);
            },
        },

        methods: {
            generateDocument() {
                generateDocument({horseId: this.horse.id, body: { type: this.documentType }}).then((response) => {
                    this.$toast.add({
                        severity: "success",
                        summary: this.$t("message.other.success"),
                        detail: this.$t("message.other.dataSaved"),
                        life: 3000,
                    });
                    this.$emit("document-generated", response.data);
                }).catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: this.$t("message.other.error"),
                        detail: error.response.data.message || this.$t("message.other.error"),
                        life: 5000,
                    });
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
@import "../../../../../assets/theme/mytheme/_variables.scss";
.horse-edit-documents-generate {
    background: var(--secondary-color);
    padding: 1.5rem;
    border-radius: 4px;

    .header {
        font-size: 1.25rem;
        font-weight: 600;
        text-transform: uppercase;
    }

    .custom-select-one {
        white-space: nowrap;
    }

    .custom-input-text, .custom-input-number, .custom-select-one {
        .p-dropdown {
            border-color: var(--text-color) !important;
        }
    }
}
</style>
